/**
 * Cancel payment request DTO
 */
export class CancelPaymentRequestDto {
	/**
	 * The ID of the payment to cancel.
	 */
	paymentId!: number;
}
